<template>
  <div class="card mb-4">
    <div class="col-12">
      <transition name="slide-fade">
        <parent-details
          v-if="isChildVisible"
          @close="hideChild"
          @kid="goToKid"
          :parent="parent"
        />
      </transition>
      <transition name="slide-fade">
        <kid-details
          v-if="isKidVisible"
          @close="hideKid"
          :kid="kid"
          :lastSeason="lastSeason"
        />
      </transition>
      <transition name="slide-fade">
        <form-edit-parent
          v-if="isEditParentVisible"
          @close="hideParent"
          @form-submitted="hideParent"
          :parent="parent"
        />
      </transition>
    </div>
    <div class="d-flex">
      <div class="card-header pb-0">
        <h6>{{ $t("parents.parents") }}</h6>
      </div>
      <div
        class="pe-md-3 d-flex align-items-center"
        :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
      >
        <div class="me-3 mt-3">
          <form class="input-group">
            <input
              type="text"
              class="form-control back"
              v-model="searchQuery"
              :placeholder="
                this.$store.state.isRTL ? 'أكتب هنا...' : $t('parents.search')
              "
            />
          </form>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("parents.parent") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("parents.sendigReminders") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-1"
              >
                {{ $t("parents.kidsCount") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-1"
              >
                {{ $t("teachers.mobile") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.activ") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("parents.notes") }}
              </th>
              <th class="text-secondary opacity-7 col-3"></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.details") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredParents" :key="item.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="item.image"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.parent_name }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      {{ item.email }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <div v-if="lastSeason && !item.deleted_at">
                  <soft-switch
                    id="flexSwitchCheckDefault"
                    name="reminder"
                    class="ms-auto"
                    label-class="mb-0 text-body ms-3 text-truncate w-80"
                    :checked="item.reminder ? true : false"
                    @change="changeReminder(item.id)"
                  />
                </div>
              </td>
              <td>
                <p class="text-center text-xs font-weight-bold mb-0">
                  {{ item.kids.length }}
                </p>
              </td>
              <td>
                <p class="text-center text-xs font-weight-bold mb-0">
                  {{ item.mobile }}
                </p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="!item.deleted_at"
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.yes") }}
                </soft-badge>
                <soft-badge
                  v-else-if="item.deleted_at"
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.no") }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  item.notes != null ? truncateString(item.notes) : ""
                }}</span>
              </td>
              <td class="align-middle text-center">
                <div v-if="lastSeason">
                  <div v-if="!item.deleted_at">
                    <a
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editParent(item)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i
                      >{{ $t("global.edit") }}
                    </a>
                    <a
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="deleteParent(item)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >{{ $t("global.delete") }}
                    </a>
                  </div>
                  <div v-else>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      class="me-3"
                      href="javascript:;"
                      @click="activateParent(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'success' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.activate") : "" }}
                      </soft-badge>
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      @click="permanentlyDeleteParent(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'danger' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="lg"
                      >
                        {{ !item.valid ? $t("global.deleteForever") : "" }}
                      </soft-badge>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="#" @click="showParent(item)">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import ParentDetails from "../components/ParentDetails";
import SoftSwitch from "@/components/SoftSwitch.vue";
import FormEditParent from "@/components/FormEditParent.vue";
import KidDetails from "./KidDetails.vue";
import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "teacher-list",
  components: {
    SoftAvatar,
    SoftBadge,
    ParentDetails,
    SoftSwitch,
    KidDetails,
    FormEditParent,
  },
  props: {
    parents: {
      type: Array,
      required: true,
      default: () => [],
    },
    closeEditForm: {
      type: Boolean,
      required: true,
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    closeEditForm(newCloseEditForm) {
      this.localCloseEditForm = newCloseEditForm;
      this.checkIsEditFormOpen();
    },
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
    filteredParents() {
      const search = this.searchQuery.trim().toLowerCase();

      if (!search) {
        this.getSearchedParents();
        this.$emit("show-pagination");
        return this.parents;
      }

      this.$emit("hide-pagination");
      return this.searchedParents.filter((parent) => {
        return parent.parent_name.toLowerCase().includes(search);
      });
    },
  },
  data() {
    return {
      parent: {},
      isChildVisible: false,
      isKidVisible: false,
      isEditParentVisible: false,
      kid: [],
      localCloseEditForm: false,
      searchedParents: this.parents,
      searchQuery: "",
    };
  },
  methods: {
    async getSearchedParents() {
      const res = await axios.get("get-searched-parents");
      this.searchedParents = res.data.parents;
    },
    editParent(parent) {
      this.parent = parent;
      this.isEditParentVisible = true;
      this.isChildVisible = false;
      this.$emit("close-create-parent");
    },
    async deleteParent(parent) {
      const test = await axios.get("check-parents-kids/" + parent.id);
      let optionalText = "";
      test.data.kids.forEach(
        (item) => (optionalText += "<br>- " + item.kid_name + ", ")
      );
      let text =
        optionalText != "" ? this.$t("parents.checkKids") + optionalText : "";
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("parent/" + parent.id);
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
            width: "64em",
          });
          this.$emit("close-edit-parent");
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    showParent(parent) {
      this.parent = parent;
      this.isChildVisible = true;
      this.$emit("close-create-parent");
      this.hideKid();
      this.hideParent();
      this.scrollToTop();
    },
    goToKid(kid) {
      this.kid = kid;
      this.isKidVisible = true;
      this.hideChild();
      this.scrollToTop();
    },
    hideChild() {
      this.isChildVisible = false;
    },
    hideKid() {
      this.isKidVisible = false;
    },
    hideParent() {
      this.isEditParentVisible = false;
      this.$emit("close-create-parent");
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    changeReminder(parentId) {
      axios.get("change-reminder-setting", {
        params: {
          parentId: parentId,
        },
      });
    },
    truncateString(str) {
      return str.length > 20 ? str.substring(0, 20) + "..." : str;
    },
    checkIsEditFormOpen() {
      if (this.localCloseEditForm) {
        this.isEditParentVisible = false;
        this.isKidVisible = false;
        this.isChildVisible = false;
        this.$emit("reset-close-edit-form");
      }
    },
    async activateParent(parent) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          /* swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          }); */
          const response = await axios.post("activate-parent", {
            parentId: parent.id,
          });
          if (response.status == 200) {
            //swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            //swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            //swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        //swal.close();
        swal.fire({
          title: this.$t("global.activationCancelled"),
          text: "",
          icon: "success",
        });
      }
      this.$emit("fetch-parents");
    },

    async permanentlyDeleteParent(parent) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("parents.parentPermanentlyDelete"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.delete(
            "permanently-delete-parent/" + parent.id
          );
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-parents");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
        this.$emit("get-parents");
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
  },
};
</script>
